module.exports = __webpack_public_path__ + "assets/img/34_727.781341d0.jpg";